/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-info-circle-xl': {
    width: 24,
    height: 24,
    viewBox: '0 0 12 13',
    data: '<defs><path pid="0" d="M1.937 2.685v.012a.568.568 0 0 1 .112.017l.056.015c.311.079.5.403.423.722l-.432 1.796-.196.81c-.181.754.564-.163.72.184.102.23-.603.707-1.108 1.07 0 0-.26.178-.439.177l-.025.012v-.012a.563.563 0 0 1-.112-.017l-.057-.014C.57 7.377.404 7.06.481 6.74l.433-1.795.196-.81c.181-.754-.577.16-.732-.188-.102-.229.59-.71 1.095-1.073 0 0 .26-.177.438-.177l.026-.012zM1.82.5c.448 0 .811.374.811.835a.824.824 0 0 1-.811.836.824.824 0 0 1-.812-.836c0-.461.363-.835.812-.835z" id="svgicon-icon-info-circle-xl-a"/></defs><g transform="translate(0 .052)" _fill="none" fill-rule="evenodd"><circle pid="1" _fill="#EEF2F4" fill-rule="nonzero" cx="6" cy="6" r="6"/><use _fill="#404040" xlink:href="#svgicon-icon-info-circle-xl-a" transform="translate(4.5 2)"/></g>'
  }
})
